// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
  overflow: hidden;
}
body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.ant-layout.page-layout {
  position: relative;
  overflow-x: hidden;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.page-header,
.page-content,
.app-footer {
  min-width: 420px;
}
.page-drawer {
  top: 64px;
  height: calc(100vh - 64px);
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.loading-overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: 0 -15px;
  background-color: rgba(255, 255, 255, 0.75);
  transition: all 0.4s ease;
  transform: scale(1);
  opacity: 1;
  z-index: 5;
  display: block;
}
.loading-indicator {
  height: 110px;
  left: 50%;
  margin: -55px 0 0 -55px;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 110px;
}
.ant-form-item-label > label {
  width: 100%;
}
span.content {
  color: rgba(0, 0, 0, 0.4);
}
.ant-input.code {
  font-family: monospace;
  white-space: nowrap;
  font-size: 12px;
}
.ant-picker {
  width: 100%;
}
.ant-breadcrumb-link a {
  border-bottom: 1px solid #999;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
